"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CaravanTruckBoxStand = function CaravanTruckBoxStand(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.1,14.44a1.29,1.29,0,1,0,1.29,1.29A1.29,1.29,0,0,0,7.1,14.44Zm0,2.08a.79.79,0,1,1,.78-.79A.78.78,0,0,1,7.1,16.52Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.73,14.44A1.29,1.29,0,1,0,22,15.73,1.29,1.29,0,0,0,20.73,14.44Zm0,2.08a.79.79,0,1,1,.78-.79A.78.78,0,0,1,20.73,16.52Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,15.26s0-.12,0-.14V15a.07.07,0,0,0,0,0v-.3s0,0,0,0,0-.29-.14-.39-.16-.09-.14-.13l.07,0s.11,0,.1,0a.49.49,0,0,0-.2-.14s-.08,0,0,0,.17,0,.17, 0a1.5,1.5,0,0,0-.13-.54c-.12-.31-.36-.91-.51-1.2,0,0,0,0-.14-.08L22.85,12s-1.51-3-1.57-3.1a3.6,3.6,0,0,0-1.17-1.31,3.26,3.26,0,0,0-1.61-.4c-.29, 0-4.11,0-4.11,0s-.08-.2-.2-.2h-2s-.08,0-.09,0a1.08,1.08,0,0,1-.08.16h-.35a.4.4,0,0,0-.21-.12,4.65,4.65,0,0,0-.55,0,.2.2,0,0,0-.15.09A1.49,1.49,0,0, 0,10.08,7a1.61,1.61,0,0,0-.72.23H1.21a1,1,0,0,0-.67.19,1.3,1.3,0,0,0-.24.75c0,.19-.06,5.11-.06,5.11l-.14.05c-.06,0-.07.09-.07.11a1.22,1.22,0,0,0,0, .38,1.56,1.56,0,0,0,0,.49.67.67,0,0,0,0,.4c0,.27.15.71.25.75a1.62,1.62,0,0,0,.46,0l4.71,0a1.67,1.67,0,0,1,3.32,0l10.3.05a1.67,1.67,0,0,1,3.33,0c.14,0, .66,0,.93-.06a1.58,1.58,0,0,0,.6-.13c0-.06,0,0,.07-.12S24,15.32,24,15.26ZM11.48,13.54a.54.54,0,0,1-.54.54H9.7a.54.54,0,0,1-.54-.54V9.66a.54.54,0,0,1, .54-.54h1.25a.54.54,0,0,1,.54.54ZM17.35,12s-.43,0-.46-.21,0-2.19,0-2.19,0-.26.33-.26h3.08L21.67,12ZM22,12,20.54,9h.58l1.62,3.19Zm.54.38a1,1,0,0,1,.81.47, 1.82,1.82,0,0,1,.38.85A2.44,2.44,0,0,1,22.56,12.43Z"
  }));
};

var _default = CaravanTruckBoxStand;
exports["default"] = _default;